import Axios from '../plugins/axios'

export const createApartment = function (apartment) {
    return Axios.post('apartments', apartment)
}

export const fetchApartments = function () {
    return Axios.get('apartments?lang=bg')
}

export const fetchApartment = function (id) {
    return Axios.get(`apartments/${id}?lang=bg`)
}

export const updateApartment = function (id, apartment) {
    return Axios.put(`apartments/${id}`, apartment)
}

// export const fetchBuildingsEntrances = function () {
//     return Axios.get('buildings/entrances?lang=bg')
// }

export const removeApartment = function (id) {
    return Axios.delete('apartments/' + id)
}